let isTimerActive = false; // Flag to track if the timer is active

function initializeTimer() {
    const display = document.getElementById('countdown-text');
    const notification = document.getElementById('free-shipping-timer-notification');
    const currentDuration = settings.drawer_show_free_shipping_duration;

    if (!display || !notification) {
        return; // Exit if elements are not found
    }

    // Check if the cart has expired
    if (localStorage.getItem('cartExpired')) {
        display.textContent = "Your cart has expired";
        notification.style.display = 'block';
        return; // Exit to avoid starting a new timer
    }

    function handleExpiration() {
        display.textContent = "Your cart has expired";
        notification.style.display = 'block';
        localStorage.setItem('cartExpired', 'true');
        localStorage.setItem('lastDuration', currentDuration);
        localStorage.removeItem('endTime');
        clearInterval(window.timerInterval);
        isTimerActive = false; // Reset the flag
    }

    function startNewTimer(duration) {
        if (isTimerActive) {
            return; // Exit if the timer is already running
        }

        isTimerActive = true; // Set the flag to indicate the timer is active
        const totalSeconds = duration * 60;
        const newEndTime = Math.floor(Date.now() / 1000) + totalSeconds;
        localStorage.setItem('endTime', newEndTime.toString());
        localStorage.setItem('lastDuration', duration.toString());
        localStorage.removeItem('cartExpired');
        display.innerHTML = `Your cart is about to expire in <span id="countdown-timer">${duration}</span> minutes`;
        notification.style.display = 'block';
        startTimer(totalSeconds);
    }

    function startTimer(duration) {
        clearInterval(window.timerInterval);
        window.timerInterval = setInterval(() => {
            if (duration <= 0) {
                clearInterval(window.timerInterval);
                handleExpiration();
            } else {
                updateDisplay(duration);
                duration--;
            }
        }, 1000);
    }

    function updateDisplay(duration) {
        const minutes = Math.floor(duration / 60);
        const seconds = duration % 60;
        display.innerHTML = `Your cart is about to expire in <span id="countdown-timer">${minutes} minute(s) and ${seconds} second(s)</span>`;
    }

    // Check for existing end time to determine if the timer should be started
    const endTime = localStorage.getItem('endTime');
    const currentTime = Math.floor(Date.now() / 1000);

    if (endTime && currentTime < parseInt(endTime)) {
        // If a valid timer already exists, start from the remaining time
        const remainingTime = parseInt(endTime) - currentTime;
        startTimer(remainingTime);
    } else {
        startNewTimer(currentDuration);
    }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    setTimeout(function() {
      var swiper = new Swiper(".cartProductSwiper", {
        slidesPerView: 1.1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      initializeTimer(); // Call this only if you want to start the timer here
    }, 1000);

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    setTimeout(function() {
      var swiper = new Swiper(".cartProductSwiper", {
        slidesPerView: 1.1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

        // Start the timer
      initializeTimer(); // Call this only if you want to start the timer here
    }, 1000);

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    setTimeout(function() {
      var swiper = new Swiper(".cartProductSwiper", {
        slidesPerView: 1.1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      initializeTimer(); // Call this only if you want to start the timer here
    }, 1000);

    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    setTimeout(function() {
      var swiper = new Swiper(".cartProductSwiper", {
        slidesPerView: 1.1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      initializeTimer(); // Ensure this function is accessible in this scope
    }, 1000);

    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    setTimeout(function() {
      var swiper = new Swiper(".cartProductSwiper", {
        slidesPerView: 1.1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      initializeTimer();
    }, 1000);

    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() { 
    setTimeout(function() {
      var swiper = new Swiper(".cartProductSwiper", {
        slidesPerView: 1.1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      initializeTimer(); // Call this only if you want to start the timer here
    }, 1000);

    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


